import AcceptOddChange from './accept-odd-change.vue';
import QuickBet from './quick-bet';

export default {
  functional: true,
  name: 'BetslipSwitches',
  props: {
    hasItems: {
      type: Boolean,
      required: true,
    }
  },
  render(h, { props, data }) {
    if (APP_SETTINGS.betslip_v2.showAcceptOddChanges && APP_SETTINGS.betslip_v2.useQuickBet) {
      return h('div', {
        class: [
          'bto-sb-betslip-acceptgroup',
          { 'bto-sb-betslip-acceptgroup-full': APP_SETTINGS.betslip_v2.splitSwitches },
          data.staticClass
        ]
      }, [h(AcceptOddChange), h(QuickBet)]
      );
    }
    if (APP_SETTINGS.betslip_v2.showAcceptOddChanges && props.hasItems) {
      return h(AcceptOddChange, { class: data.staticClass });
    }
    if (APP_SETTINGS.betslip_v2.useQuickBet) {
      return h(QuickBet, { class: data.staticClass });
    }
  }
}